import { Input, Spin } from 'antd';
import { MagnifyingGlass } from '@phosphor-icons/react';
import { IconSizes } from '@utility/constants/style-contants';

/** Input for AutoComplete search fields — shows a spinner instead of the clear icon while loading. */
export function AutocompleteSearchInput({
  isSearching = false,
  size = undefined,
  allowClear = true,
  onClear = undefined,
  prefix = <MagnifyingGlass size={IconSizes.small} />,
  disabled = undefined,
  ...rest
}) {
  const resolvedSize = size === 'mini' ? 'small' : size;

  return (
    <Input
      size={resolvedSize}
      disabled={disabled}
      allowClear={allowClear && !isSearching}
      suffix={isSearching ? <Spin size="small" /> : undefined}
      onClear={onClear}
      prefix={prefix}
      {...rest}
    />
  );
}
